import React from 'react';
import { MegaphoneIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useActiveAnnouncement } from '../../../services';
import { AnnouncementColorType } from '../../../services/announcements/types';

const colorMap: Record<AnnouncementColorType, { bg: string; text: string; hover: string }> = {
    info: { bg: 'bg-blue-400', text: 'text-blue-900', hover: 'hover:text-blue-700' },
    warning: { bg: 'bg-amber-400', text: 'text-amber-900', hover: 'hover:text-amber-700' },
    success: { bg: 'bg-green-400', text: 'text-green-900', hover: 'hover:text-green-700' },
    error: { bg: 'bg-red-400', text: 'text-red-900', hover: 'hover:text-red-700' },
};

export const NotificationBar: React.FunctionComponent = (): React.ReactElement | null => {
    const [activeAnnouncement, { dismiss, refresh }] = useActiveAnnouncement();

    React.useEffect(() => {
        refresh();
    }, []);

    if (!activeAnnouncement) return null;

    const colors = colorMap[activeAnnouncement.color_type] || colorMap.info;

    return (
        <div className={`w-full ${colors.bg} ${colors.text} px-4 py-2 flex items-center justify-between text-sm print:hidden`}>
            <div className="flex items-center gap-x-2 flex-1 justify-center">
                <MegaphoneIcon className="h-5 w-5 shrink-0" />
                <span className="font-semibold">{activeAnnouncement.title}</span>
                <span className="hidden sm:inline">—</span>
                <span className="hidden sm:inline">{activeAnnouncement.message}</span>
            </div>
            <button
                onClick={() => dismiss()}
                className={`ml-4 shrink-0 ${colors.hover} transition-colors`}
            >
                <XMarkIcon className="h-5 w-5" />
            </button>
        </div>
    );
};
